let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hmUGS")).then(() => parcelRequire('1azj7'));